import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { useSkeleton } from '../hooks/useSkeleton.js';
import { c as colors } from '../colors.module-64858915.js';
import '@alfalab/core-components-skeleton/esm';
import '@alfalab/hooks';

var styles = {"paragraph":"typography__paragraph_rpr5l","paragraphWithMargins":"typography__paragraphWithMargins_rpr5l","primary-large":"typography__primary-large_rpr5l","primary-medium":"typography__primary-medium_rpr5l","primary-small":"typography__primary-small_rpr5l","secondary-large":"typography__secondary-large_rpr5l","secondary-medium":"typography__secondary-medium_rpr5l","secondary-small":"typography__secondary-small_rpr5l","component":"typography__component_rpr5l","caps":"typography__caps_rpr5l","bold":"typography__bold_rpr5l","medium":"typography__medium_rpr5l","regular":"typography__regular_rpr5l","monospace":"typography__monospace_rpr5l","rowLimit1":"typography__rowLimit1_rpr5l","rowLimit2":"typography__rowLimit2_rpr5l","rowLimit3":"typography__rowLimit3_rpr5l"};
require('./index.css')

var Text = forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.view, view = _d === void 0 ? 'primary-medium' : _d, _e = _a.tag, Component = _e === void 0 ? 'span' : _e, weight = _a.weight, _f = _a.monospaceNumbers, monospaceNumbers = _f === void 0 ? false : _f, _g = _a.defaultMargins, defaultMargins = _g === void 0 ? true : _g, color = _a.color, className = _a.className, dataTestId = _a.dataTestId, children = _a.children, rowLimit = _a.rowLimit, showSkeleton = _a.showSkeleton, skeletonProps = _a.skeletonProps, restProps = __rest(_a, ["view", "tag", "weight", "monospaceNumbers", "defaultMargins", "color", "className", "dataTestId", "children", "rowLimit", "showSkeleton", "skeletonProps"]);
    var _h = useSkeleton(showSkeleton, skeletonProps), renderSkeleton = _h.renderSkeleton, textRef = _h.textRef;
    var skeleton = renderSkeleton({
        wrapperClassName: cn((_b = {},
            _b[styles.paragraphWithMargins] = Component === 'p' && defaultMargins,
            _b)),
        dataTestId: dataTestId,
    });
    if (skeleton) {
        return skeleton;
    }
    return (React.createElement(Component, __assign({ className: cn((_c = {},
            _c[styles.paragraph] = Component === 'p' && !defaultMargins,
            _c[styles.paragraphWithMargins] = Component === 'p' && defaultMargins,
            _c[styles.monospace] = monospaceNumbers,
            _c[styles["rowLimit".concat(rowLimit)]] = rowLimit,
            _c), className, color && colors[color], styles[view], weight && styles[weight]), "data-test-id": dataTestId, ref: mergeRefs([ref, textRef]) }, restProps), children));
});

export { Text };
